__webpack_require__.p = "/konekmobile/";